import { useRouter } from "next/router";
import { useTranslation } from "../../core/translation.core";
import { TagFormData } from "../../types/tag";
import useShop from "../../hooks/useShop.hook";
import { EditorSection, SubmitPanel, Title } from "../reuseables/editor.comp";
import { LocalInputDefaultLocale } from "../locale/locale.comp";
import { UseFormReturn } from "react-hook-form";
import { UseMutationResult } from "@tanstack/react-query";

export default function TagEditor({
  methods,
  mutation,
  btnName,
}: {
  methods: UseFormReturn<TagFormData, any>;
  mutation: UseMutationResult<void, unknown, TagFormData, unknown>;
  btnName: string;
}) {
  const { t, msg } = useTranslation();
  const selectedShop = useShop();
  const { push } = useRouter();

  async function onSubmit(data: TagFormData) {
    mutation.mutate(data);
  }

  if (!selectedShop) return null;

  return (
    <form onSubmit={methods.handleSubmit(onSubmit)} className="pb-20">
      <EditorSection>
        <Title>{t(msg.tag.name)}</Title>
        <div className="text-xs flex flex-col gap-4">
          <LocalInputDefaultLocale register={methods.register} fieldName="name" />
        </div>
      </EditorSection>
      <EditorSection>
        <Title>{t(msg.tag.slug)}</Title>
        <div className="text-xs flex flex-col gap-4">
          <LocalInputDefaultLocale register={methods.register} fieldName="slug" />
        </div>
      </EditorSection>
      <SubmitPanel>
        <button onClick={() => push("/tags")}>{t(msg.form.cancel)}</button>
        <input type="submit" value={btnName} />
      </SubmitPanel>
    </form>
  );
}
